module.exports = __webpack_public_path__ + "img/report-4.0b7ba6b2.jpg";